export const DEFAULT_PATH = '/acc'
export const ACCOUNT_SETUP_PATH = '/acc/account-setup'
export const HOMEPAGE_PATH = '/acc/home-page'
export const MY_COMPANY_PATH = '/acc/my-company'
export const CREATE_PRODUCER_PATH = '/acc/producer/create'
export const EDIT_PRODUCER_PATH = '/acc/producer/:id/edit'
export const VIEW_PRODUCER_PATH = '/acc/producer/:id'
export const CREATE_BRAND_PATH = '/acc/brand/create'
export const VIEW_BRAND_PATH = '/acc/brand/:id'
export const EDIT_BRAND_PATH = '/acc/brand/:id/edit'
export const EDIT_OFFER_PATH = '/acc/sell-wine/offer/:id/edit'

export const DATABASE_PATH_PREFIX = '/acc/database'

export const SELL_WINE_PATH = '/acc/sell-wine'
export const SELL_WINE_MY_OFFERS_ALL_PATH = '/acc/sell-wine/my-offers/all'
export const SELL_WINE_REQUEST_WINES_PATH = '/acc/sell-wine/requests/:id/wines'

export const BUY_WINE_PATH = '/acc/buy-wine'
export const BUY_WINE_MY_OFFERS_ALL_PATH = '/acc/buy-wine/offers/all'
export const BUY_WINE_NEW_REQUEST_PATH = '/acc/buy-wine/my-requests/create'
export const BUY_WINE_MY_REQUESTS_PATH = '/acc/buy-wine/my-requests'
export const BUY_WINE_WINES = '/acc/buy-wine/wines'

export const CREATE_WINE_PATH = '/acc/wine/create'
export const EDIT_WINE_PATH = '/acc/wine/:id/edit/:tab'
export const VIEW_WINE_PATH = '/acc/product/:slug'
export const VIEW_WINE_SLUG_PATH = '/acc/wine/:wine/:product?'
export const WINE_RATING_PATH = '/acc/product/:slug/:geoIndicationId'
export const CREATE_COMPANY = '/acc/company/create'
export const EDIT_COMPANY = '/acc/company/:id/edit'
export const LOGIN_PAGE_PATH = '/acc/login'
export const SIGNUP_PAGE_PATH = '/acc/signup'
export const PAYMENT_PAGE_PATH = '/acc/payment'

export const ADMIN_PATH = '/acc/administration'
export const ADMIN_IMAGES = '/acc/administration/images'
export const ADMINISTRATION_ADD_IMAGES = '/acc/administration/images/create'

export const CAPTURED_WINES_PATH = '/acc/captured-wines'
export const CAPTURED_WINE_PATH = '/acc/captured-wine/:id'
export const PUBLIC_CAPTURED_WINE_PATH = '/:lang/public-captured-wine/:id'

export const MY_WINES_PATH = '/acc/my-wines'
export const MY_WINES_ALL_PATH = '/acc/my-wines/wines/all'
export const MY_WINES_SHORTLIST_PATH = '/acc/my-wines/wines/shortlist'
export const MY_WINES_E_LABELS = '/acc/e-labels'

export const REVIEWS_PATH = '/acc/reviews'
export const REVIEWS_DASHBOARD = REVIEWS_PATH + '/dashboard'
export const REVIEWS_COMPANY_REVIEWS = REVIEWS_PATH + '/company-reviews'
export const REVIEWS_MY_REVIEWS = REVIEWS_PATH + '/my-reviews'

export const EDIT_REVIEW = '/acc/review/:id/:action'
export const BUY_REVIEW = '/acc/reviews/company-reviews/request-buy-review'

export const ADMINISTRATION_MERCHANT_CREATE =
  '/acc/administration/e-shop/create'
export const ADMINISTRATION_MERCHANT_EDIT =
  '/acc/administration/e-shop/:id/edit'
export const ADMINISTRATION_WINE_SITES = '/acc/administration/wine-sites'
export const ADMINISTRATION_CLUSTERS = '/acc/administration/clusters'
export const ADMINISTRATION_VERIFIED_RELATIONS =
  '/acc/administration/verified-relations'
export const ADMINISTRATION_TRADE_OFFERS = '/acc/administration/retail-offers'
export const ADMINISTRATION_RETAIL_PUBLIC_PAGES =
  '/acc/administration/retail-public-pages'
export const ADMINISTRATION_RETAIL_PUBLIC_PAGE_CREATE =
  '/acc/administration/retail-public-page/create'
export const ADMINISTRATION_TRADE_OFFER_CREATE =
  '/acc/administration/retail-offer/create'
export const ADMINISTRATION_TRADE_OFFER_EDIT =
  '/acc/administration/retail-offer/:id/edit'
export const ADMINISTRATION_OFFERS = '/acc/administration/offers'
export const ADMINISTRATION_MENTIONS = '/acc/administration/mentions'
export const ADMINISTRATION_MENTIONS_PRICES =
  '/acc/administration/mentions-prices'
export const ADMINISTRATION_MENTIONS_FACTS =
  '/acc/administration/mentions-facts'
export const ADMINISTRATION_CLUSTERS_LINK_MENTIONS =
  '/acc/administration/mentions/:id/cluster/link-mentions'
export const ADMINISTRATION_MENTIONS_CLUSTER_PATH =
  '/acc/administration/mentions/:sourceId/path/:destId'
export const ADMINISTRATION_ADD_MENTION = '/acc/administration/mentions/create'

export const ADMINISTRATION_RETAIL_OFFER_PRICE =
  '/acc/retail-offer-price/:id/create'
export const RETAIL = '/acc/retail'
export const RETAIL_WINES = '/acc/retail/wines'
export const RETAIL_GEO_INDICATIONS = '/acc/retail/geo-indications'
export const ADMINISTRATION_REQUEST_VIEW = '/acc/administration/request/:id'
